var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cookie-law',{attrs:{"buttonClass":"button is-primary is-medium","message":_vm.$t('global.cookieNotice.message'),"buttonText":_vm.$t('global.cookieNotice.button')}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a4f5f8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/global/components/CookieNotice.vue
// module id = x0II
// module chunks = 1